var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 6.4c-2.6 0-4.8 2.1-4.8 4.7s2.1 4.7 4.8 4.7 4.8-2.1 4.8-4.7c-.1-2.6-2.2-4.7-4.8-4.7zm0-1.9c3.7 0 6.7 3 6.7 6.6 0 1.5-.5 2.8-1.3 3.9l2.7 2.7c.3.3.4.9.1 1.3l-.1.1c-.4.4-1 .4-1.3 0l-2.7-2.8c-1.1.8-2.5 1.3-4 1.3-3.7 0-6.7-3-6.7-6.6s2.9-6.5 6.6-6.5z"
  })));
}

export default SvgSearch;